"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _Icon = _interopRequireDefault(require("@cimpress/react-components/lib/Icon"));

var _TextField = _interopRequireDefault(require("@cimpress/react-components/lib/TextField"));

var _emotion = require("emotion");

var _react = _interopRequireDefault(require("react"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: flex-end;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var searchHeaderStyle = (0, _emotion.css)(_templateObject());
var searchBarDefaultStyle = (0, _emotion.css)(_templateObject2());
var defaultIconStyle = {
  marginTop: '17px',
  paddingRight: '35px',
  position: 'absolute',
  zIndex: 1000
};

var SearchBar = function SearchBar(props) {
  var className = props.className,
      iconStyle = props.iconStyle,
      searchBarStyle = props.searchBarStyle,
      value = props.value,
      onChange = props.onChange;
  return _react.default.createElement("div", {
    className: (0, _emotion.cx)(searchHeaderStyle, className)
  }, _react.default.createElement(_TextField.default, {
    label: "Search Price Models",
    value: value,
    onChange: onChange,
    className: searchBarStyle || searchBarDefaultStyle
  }), _react.default.createElement(_Icon.default, {
    name: "search",
    size: "lg",
    style: iconStyle || defaultIconStyle,
    color: colors.ocean.base
  }));
};

var _default = SearchBar;
exports.default = _default;